/* eslint @typescript-eslint/naming-convention: 0 */

export type WaitlistFormLocation = 'booking_section' | 'date_drawer';

export interface WaitlistFunnelParams {
  /** purchase の item_id と突き合わせるため、体験の slug を送る */
  experience_id: string;
  location: WaitlistFormLocation;
}

export const buildWaitlistFunnelParams = (experienceSlug: string, location: WaitlistFormLocation): WaitlistFunnelParams => {
  return { experience_id: experienceSlug, location };
};
